import { html } from 'common-tags';
import lscache from 'lscache';
import Request from 'superagent';
import { parseItems } from './modules/_utilities';

(function ($) {
	let eventRecord = ({ event }) => {
		let location =
			(event.City !== '' ? event.City + ', ' : '') + event.State;
		return html`
			<div class="event col-xs-12">
				<div class="event-container row">
					<div class="columns col-xs-12 title">
						<h3>${event.Title}</h3>
					</div>
					<div class="columns col-xs-12 description">
						${event.Description}
					</div>
					<div class="columns col-xs-12 link">
						<a href="/Event.aspx?EventKey=${event.Code}">Details</a>
					</div>
					<div class="columns col-xs-12 date">
						<strong>When:</strong> ${event.BeginDate}
					</div>
					<div class="columns col-xs-12 location">
						<strong>Where:</strong> ${location}
					</div>
				</div>
			</div>
		`;
	};

	$(window).load(function () {
		$('.event-listings').each(function (i, el) {
			var cache = $(el).data('listing');
			var src = $(el).data('listingSrc');
			var limit = $(el).data('limit');
			var wordLength = $(el).data('descriptionLength');
			if (limit === 'undefined' || limit === undefined) {
				limit = 100;
			}
			if (wordLength === 'undefined' || wordLength === undefined) {
				wordLength = 50;
			}
			getData(cache, src).then(
				function (data) {
					if (data.length > 0) {
						$('.events', el)
							.empty()
							.html(
								data
									.slice(0, limit)
									.map((event) => {
										if (event.Description) {
											event.Description = truncate(
												event.Description,
												wordLength
											);
										}
										return eventRecord({ event });
									})
									.join('')
							);
						if ( $.isFunction($.fn.matchHeight) ) {
							$.fn.matchHeight._update();
						}
					} else {
						$('.events', el)
							.empty()
							.html(
								'<div class="noEvents"><h3>No upcoming events</h3></div>'
							);
					}

					$(el).data('events', data);
				},
				function (err) {
					//eslint-disable-next-line no-console
					$('.events', el)
						.empty()
						.html(
							'<div class="error"><h3>Error loading events</h3></div>'
						);
					console.log(err);
				}
			);
		});

		// $('.job-listings .filter').click(function (evnt) {
		// 	var el = $(evnt.target);
		// 	var parent = $(el).closest('.job-listings');
		// 	var items = $(parent).data('jobs');
		// 	var filteredItems = $(parent).data('searchJobs');
		// 	var template = $(parent).data('template');
		// 	var dir = $(el).data('dir');
		// 	var field = $(el).data('filter');
		// 	if (template === 'undefined' || template === undefined) {
		// 		template = 'internal';
		// 	}
		// 	$(parent)
		// 		.find('.filter')
		// 		.removeClass('sort-asc')
		// 		.removeClass('sort-desc');
		// 	if (dir === 'undefined' || dir === undefined) {
		// 		dir = 'asc';
		// 		$(el).data('dir', 'asc');
		// 		$(el).addClass('sort-asc');
		// 	} else if (dir === 'asc') {
		// 		dir = 'desc';
		// 		$(el).data('dir', 'desc');
		// 		$(el).addClass('sort-desc');
		// 	} else {
		// 		dir = 'asc';
		// 		$(el).data('dir', 'asc');
		// 		$(el).addClass('sort-asc');
		// 	}
		// 	if (dir !== 'asc') {
		// 		field = '-' + field;
		// 	}
		// 	if (
		// 		filteredItems &&
		// 		filteredItems !== undefined &&
		// 		filteredItems !== 'undefined'
		// 	) {
		// 		filteredItems.sort(fieldSorter(field.split(' ')));
		// 		$('.jobs', parent)
		// 			.empty()
		// 			.html(
		// 				filteredItems
		// 					.map((job) => {
		// 						return eventRecord({ job, template });
		// 					})
		// 					.join('')
		// 			);
		// 	} else {
		// 		items.sort(fieldSorter(field.split(' ')));
		// 		$('.jobs', parent)
		// 			.empty()
		// 			.html(
		// 				items
		// 					.map((job) => {
		// 						return eventRecord({ job, template });
		// 					})
		// 					.join('')
		// 			);
		// 	}
		// });

		// $('.job-listings .search .search-submit').click(function (e) {
		// 	e.preventDefault();

		// 	var el = $(e.target);
		// 	var parent = $(el).closest('.job-listings');
		// 	var items = $(parent).data('jobs');
		// 	var searchField = $('.search-in', parent);
		// 	var searchBox = $('.search-text', parent);
		// 	var template = $(parent).data('template');
		// 	if (template === 'undefined' || template === undefined) {
		// 		template = 'internal';
		// 	}
		// 	if (
		// 		items !== null &&
		// 		items.length > 0 &&
		// 		searchField !== null &&
		// 		searchBox !== null &&
		// 		searchBox.val() !== ''
		// 	) {
		// 		var field = $(searchField).val();
		// 		var searchText = searchBox.val();
		// 		if (items[0].hasOwnProperty(field)) {
		// 			var filteredItems = items.filter((job) => {
		// 				if (
		// 					job[field] !== undefined &&
		// 					job[field] !== null &&
		// 					job[field] !== '' &&
		// 					job[field].indexOf(searchText) >= 0
		// 				)
		// 					return job;
		// 			});

		// 			$.each($(parent).find('.filter'), function (i, f) {
		// 				$(f).removeData('dir');
		// 				$(f).removeClass('sort-asc').removeClass('sort-desc');
		// 				if ($(f).data('filter').indexOf(field) >= 0) {
		// 					$(f).data('dir', 'asc');
		// 					$(f).addClass('sort-asc');
		// 				}
		// 			});
		// 			filteredItems.sort(fieldSorter(field.split(' ')));
		// 			$('.jobs', parent)
		// 				.empty()
		// 				.html(
		// 					filteredItems
		// 						.map((job) => {
		// 							return eventRecord({ job, template });
		// 						})
		// 						.join('')
		// 				);
		// 			$('.search-clear', parent).show();
		// 			$(parent).data('searchJobs', filteredItems);
		// 		}
		// 	}
		// 	$(parent).focus();
		// 	return false;
		// });
		// $('.job-listings .search .search-clear').click(function (e) {
		// 	e.preventDefault();

		// 	var el = $(e.target);
		// 	var parent = $(el).closest('.job-listings');
		// 	var items = $(parent).data('jobs');
		// 	var template = $(parent).data('template');
		// 	if (template === 'undefined' || template === undefined) {
		// 		template = 'internal';
		// 	}
		// 	if ($(parent).find('.filter').length > 0) {
		// 		var filter = $($(parent).find('.filter')[0]).data('filter');
		// 		items.sort(fieldSorter(filter.split(' ')));
		// 		$.each($(parent).find('.filter'), function (i, f) {
		// 			$(f).removeData('dir');
		// 			$(f).removeClass('sort-asc').removeClass('sort-desc');
		// 			if ($(f).data('filter').indexOf(filter) === 0) {
		// 				$(f).data('dir', 'asc');
		// 				$(this).addClass('sort-asc');
		// 			}
		// 		});
		// 	}
		// 	$('.jobs', parent)
		// 		.empty()
		// 		.html(
		// 			items
		// 				.map((job) => {
		// 					return eventRecord({ job, template });
		// 				})
		// 				.join('')
		// 		);
		// 	$(this).hide();
		// 	$('.search-text', parent).val('');
		// 	$(parent).removeData('searchJobs');
		// 	$(parent).focus();
		// 	return false;
		// });
	});

	function getData(cache, src) {
		var def = $.Deferred();
		var cacheData = lscache.get(cache);
		let cacheTime = 720;
		let limit = 500;
		if (cacheData === null) {
			Request.get(src)
				.query({ limit: limit })
				.use((req) => {
					req.header.contentType = 'application/json';
					req.header.RequestVerificationToken = $(
						'#__RequestVerificationToken'
					).val();
					return req;
				})
				.then((response) => {
					let resData = response.body;
					if (resData && resData.hasOwnProperty('Items')) {
						let items = resData.Items.$values;
						//console.log(items);
						if (
							resData.hasOwnProperty('Count') &&
							resData.hasOwnProperty('TotalCount')
						) {
							var totalCount = Math.trunc(
								resData.TotalCount / resData.Limit
							);
							var remainder = resData.TotalCount % resData.Limit;
							if (remainder > 0) totalCount++;
							let response_count = 1;
							if (response_count === totalCount) {
								let events = parseItems(items);
								lscache.set(cache, events, cacheTime);
								def.resolve(events);
							} else {
								let offset = resData.Limit;
								for (let i = 2; i <= totalCount; i++) {
									offset = limit * (i - 1);
									Request.get(src)
										.query({ limit: limit, offset: offset })
										.use((req) => {
											req.header.contentType =
												'application/json';
											req.header.RequestVerificationToken =
												$(
													'#__RequestVerificationToken'
												).val();
											return req;
										})
										.then((response) => {
											response_count++;
											resData = response.body;
											if (
												resData &&
												resData.hasOwnProperty('Items')
											) {
												items = items.concat(
													resData.Items.$values
												);
												if (
													response_count ===
													totalCount
												) {
													let events =
														parseItems(items);
													lscache.set(
														cache,
														events,
														cacheTime
													);
													def.resolve(events);
												}
											}
										});
								}
							}
						}
					}
				});
		} else {
			def.resolve(cacheData);
		}
		return def.promise();
	}

	function truncate(str, no_words) {
		return str.split(' ').splice(0, no_words).join(' ').concat('...');
	}
})(jQuery);



// WEBPACK FOOTER //
// ./theme_components/js/upcoming-events.js